import SalesFile from './salesFileResource';
import transformError from '../shared/transformers/errorTransformer';

function getSalesFile(range) {
  return SalesFile.get(range);
}

function sendSalesFileToEmail({ email, range = {} }) {
  return SalesFile.sendSalesFileToEmail({
    ...range,
    send_to: email,
    is_async: true,
  }).catch(transformError);
}

export default {
  getSalesFile,
  sendSalesFileToEmail,
};
